var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showImage),expression:"showImage"}],attrs:{"id":"viewImage"}},[_c('div',{staticClass:"image-preview-container"},[_c('img',{staticClass:"preview-image",attrs:{"src":_vm.url}}),_c('span',{staticClass:"el-icon-close close-icon",on:{"click":_vm.closeImage}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }